module.exports = __webpack_public_path__ + "img/hva.2f35bb72.png";